import { Button } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { confirm } from "lib/@dialogs/confirm"
import Iconify from "minimals-template/components/Iconify"
import { updateTailoredAuditReason } from "lib/@offline/queued-audits"
import { If } from "lib/@components/switch"
import { successSnackbar } from "lib/snackbar/success-snackbar"

export function RemoveJustification() {
    const { justification, setJustification, tailoringAudit, setTailoringAudit } = useBoundContext()

    return (
        <If truthy={justification?.reason}>
            <Button
                startIcon={<Iconify icon="mdi:bin" />}
                onClick={handleRemove}
                color="error"
                data-cy="remove-justification-button"
            >
                Remove
            </Button>
        </If>
    )

    async function handleRemove() {
        if (
            await confirm(
                "This action is permanent and can't be undone. The justification will be permanently deleted.",
                "Delete Justification",
                undefined,
                "Delete"
            )
        ) {
            const cleared = await updateTailoredAuditReason(tailoringAudit.id, "")
            // Show the removal immediately rather than after the invalidation refetch (FIQ-682)
            if (cleared && typeof cleared === "object") {
                setTailoringAudit?.(cleared)
            }
            setJustification(null)
            successSnackbar("Successfully removed justification")
        }
    }
}
